import React, { Fragment } from 'react'
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import LabUserHome from './LabUserHome';
import { Breadcrumbs } from '../../AbstractElements';

export default function LabUserList() {
    return (
        <Fragment>            
            <Breadcrumbs mainTitle="List Of Lab Users" parent="Home" title="List Of Lab Users" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <LabUserHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
